import PropTypes from 'prop-types'

/**
 * PropType defining a federal state / county for addresses from countries like GB/US/CA/MX
 *
 * @property {string}               code               - standard federal code for this state/county
 * @property {string}               stringCode         - stringCode to translate the state name
 */
export const federalStatePropType = PropTypes.shape({
    code: PropTypes.string.isRequired,
    stringCode: PropTypes.string.isRequired
})
